var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTravel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 86,
    viewBox: "0 0 72 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.1641 0V86H71.1641V0H70.1641Z",
    fill: "#E6E6E6",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.28969 58.75H49.0397V63.25H6.28969V58.75ZM50.3222 37.69C49.8497 35.89 47.9822 34.81 46.1822 35.305L34.2347 38.5L18.6647 24.0325L14.3672 25.18L23.6822 41.3125L12.4997 44.305L8.06719 40.84L4.80469 41.7175L8.89969 48.8275L10.6322 51.82L14.2322 50.875L26.1797 47.6575L35.9672 45.0475L47.9147 41.875C49.7372 41.335 50.7947 39.49 50.3222 37.69Z",
    fill: "url(#paint0_linear_2645_9165)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2645_9165",
    x1: 4.80469,
    y1: 45.0738,
    x2: 50.8631,
    y2: 45.0065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#880000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#042449"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravel);
export default __webpack_public_path__ + "static/media/Travel.6fc88ccc40ba2bf8ae0b9abcf8dd6a4f.svg";
export { ForwardRef as ReactComponent };